const SAVE_STEP_PRESENTATION = 'publicador/step4Module2/SAVE_STEP_PRESENTATION';
const GET_STEP_PRESENTATION = 'publicador/step4Module2/GET_STEP_PRESENTATION';

export { SAVE_STEP_PRESENTATION, GET_STEP_PRESENTATION };
